import React, { useState, useEffect } from "react";
import { NavLink, Link, useNavigate, useLocation } from "react-router-dom";
import { Modal } from "antd";
import logo from '../Assets/Logo/logo-dark.png';
import { useSelector, useDispatch } from 'react-redux';
import projectApi from "../../API/ProjectAPI";
import { setProjectList } from "../../Reducers/Project/ProjectSlice";
import { CloseOutlined } from '@ant-design/icons';

const Layout = ({ children }) => {
  const [isLoggedIn, setIsLoggedIn] = useState(true);
  const navigate = useNavigate();
  const { confirm } = Modal;
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isUserMenuOpen, setIsUserMenuOpen] = useState(false);
  const [isServiceMenuOpen, setIsServiceMenuOpen] = useState(false);
  const [iconStyle, setIconStyle] = useState(true)
  const location = useLocation();
  const navigation = location.pathname;
  const projects = useSelector((state) => state.project.list);
  const dispatch = useDispatch();


  const handleMenuToggle = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const handleUserMenuToggle = () => {
    setIsUserMenuOpen(!isUserMenuOpen);
  };
  const handleServiceMenuToggle = () => {
    setIsServiceMenuOpen(!isServiceMenuOpen);
  };

  useEffect(() => {
    setIconStyle(false)
  }, [])

  const userImage = useSelector((state) => state.userImage);
  const showLogoutConfirmation = () => {
    confirm({
      title: (
        <div style={{position:"relative"}}>
          <span>Are you sure you want to logout?</span>
          <CloseOutlined style={{
          position: "absolute",
          top: "-8px",
          right: "-10px",
        }}  onClick={()=>{Modal.destroyAll();}}/>
        </div>
      ),
      okText: 'YES',
      okType: 'danger',
      cancelText: 'NO',
      onOk() {
        handleLogout();
      },
      onCancel() {
        console.log('Cancel');
      },
    });
  };

  const handleLogout = () => {
    // Clear access token from local storage
    localStorage.removeItem('accessToken');

    setIsLoggedIn(false);

    window.history.replaceState(null, null, '/');

    navigate('/');
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const data = await projectApi.getProjectList();
        dispatch(setProjectList(data));
      } catch (error) {
        console.error('Error fetching project list:', error.message);
      }
    };

    fetchData();
  }, [dispatch]);


  return (

    <div className="wrapper dashboard">
      <nav className="main-header navbar navbar-expand navbar-white navbar-light">
        {/* <!-- Left navbar links --> */}
        <ul className="navbar-nav">
          <li className="nav-item">
            <a className="nav-link" data-widget="pushmenu" href="#" role="button"><i className="fas fa-bars"></i></a>
          </li>

        </ul>

        {/* <!-- Right navbar links --> */}
        <ul className="navbar-nav ml-auto">

          <li className="nav-item me-3">
            <a className="nav-link" data-widget="fullscreen" href="#" role="button">
              <i className="fas fa-expand-arrows-alt"></i>
            </a>
          </li>

          <li className="nav-item d-flex align-items-center">
            <span className="">
              {" "}
              <img src={`data:image/jpeg;base64,${userImage}`} alt="" className="img-circle " />
            </span>
            <div className="nav-item dropdown d-inline-block">
              <a className="nav-link d-flex align-items-center" data-toggle="dropdown" href="#">
                <h5 className="header-font mb-0">{localStorage.getItem("userName")}</h5>
              </a>
              <div className="dropdown-menu custom-dropdown p-0 text-center">
                <div className="border-bottom">
                  <Link to="/userprofile" 
                  className="text-decoration-none logout-font d-block p-1">PROFILE</Link>
                </div>
                <div>
                <Link onClick={() => showLogoutConfirmation()} className="text-decoration-none logout-font d-block p-1">LOGOUT</Link>
                </div>
              </div>
            </div>
          </li>
          {/* <li className="nav-item">
            <a className="nav-link" data-widget="control-sidebar" data-controlsidebar-slide="true" href="#" role="button">
              <i className="fas fa-th-large"></i>
            </a>
          </li> */}
        </ul>

      </nav>
      {/* <!-- /.navbar --> */}


      {/* <!-- Main Sidebar Container --> */}
      <aside className="main-sidebar sidebar-dark-primary elevation-4">
        {/* <!-- Brand Logo --> */}
        <a href="#" className="brand-link d-flex align-items-center justify-content-center py-2 second-img">
          <img
            src={logo}
            alt="Logo"
            className="logo-dark first-img"
            style={{ opacity: ".8" }}
          />
          <span className="second-img"><img
            src="/favicon.ico"
          /></span>

        </a>

        {/* <!-- Sidebar --> */}
        <div className="sidebar">

          {/* <!-- Sidebar Menu --> */}
          <nav className="mt-5">
            <ul className="nav nav-pills nav-sidebar flex-column" data-widget="treeview" role="menu" data-accordion="false">
              <li className="nav-item">
                <Link to='/dashboard' className={`nav-link ${navigation === '/dashboard' || navigation === '/Dashboard' || navigation === '*' ? 'active' : ''} `}>
                  <i className="nav-icon fas fa-tachometer-alt me-2"></i>
                  <p>Dashboard</p>
                </Link>
              </li>
              <li className="nav-item">
                <Link to='/clients/0' className={`nav-link ${navigation === '/clients/0' || navigation.startsWith('/clientview/') || navigation.startsWith('/clientservicequestion/') ? 'active' : ''} `}>
                  <i className="fas fa-users nav-icon me-2"></i>
                  <p>Clients</p>
                </Link>
              </li>



              <li className={`nav-item ${iconStyle ? "menu-open" : ""}`}>
                <Link to="" className={`nav-link ${projects.some(project => navigation === `/legaltools/${project.serviceName.replace(/\s+/g, '')}/${project.serviceId}`) || navigation.startsWith('/singlememberservicequestion/') ? 'active' : ''}`} onClick={() => { setIconStyle(!iconStyle) }}>
                  <i className="nav-icon fa-solid fa-gavel"></i>
                  <p>
                    Legal Tools
                    <i className="right fas fa-angle-left" />
                  </p>
                </Link>
                <ul className="nav nav-treeview">
                  {projects.map(project => (
                    <li key={project.serviceId} className="nav-item">
                      <Link
                        to={`/legaltools/${project.serviceName.replace(/\s+/g, '')}/${project.serviceId}`}
                        className={`nav-link ${navigation === `/legaltools/${project.serviceName.replace(/\s+/g, '')}/${project.serviceId}` ||
                            new RegExp(`/singlememberservicequestion/[^/]+/${project.serviceId}`).test(navigation)
                            ? 'active'
                            : ''
                          }`}
                      >
                        <i className="far fa-circle nav-icon" />
                        <p>{project.serviceName}</p>
                      </Link>
                    </li>
                  ))}
                </ul>
              </li>


              {/* <li className="nav-item">
                <Link to='/services' className={`nav-link ${navigation === '/services' || navigation.startsWith('/servicesdetail/') ? 'active' : ''} `}>
                  <i className="fas fa-copy nav-icon me-2"></i>
                  <p>Services</p>
                </Link>
              </li> */}





              <li className="nav-item">
                <Link to='/agreements' className={`nav-link ${navigation === '/agreements' ? 'active' : ''} `}>
                  <i className="fas fa-file-contract nav-icon me-2"></i>
                  <p>Terms</p>
                </Link>
              </li>

              <li className={`nav-item ${isMenuOpen ? 'menu-open' : ''}`}>
                <Link className={`nav-link ${navigation === '/paymenthistory' || navigation === '/abondentcard' ? 'active' : ''} `} onClick={handleMenuToggle}>
                  <i className="nav-icon fas fa-file-lines" />
                  <p>
                    Reports
                    <i className="right fas fa-angle-left" />
                  </p>
                </Link>
                <ul className="nav nav-treeview">
                  <li className="nav-item">
                    <Link to='/paymenthistory' className={`nav-link ${navigation === '/paymenthistory' ? 'active' : ''} `}>
                      <i className="fas fa-money-check-dollar nav-icon me-2"></i>
                      <p>Payment History</p>
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link to='/abandonedcart' className={`nav-link ${navigation === '/abandonedcart' ? 'active' : ''} `}>
                      <i className="fas fa-file-invoice nav-icon me-2"></i>
                      <p>Abandoned Cart</p>
                    </Link>
                  </li>
                </ul>
              </li>

              <li className={`nav-item ${isUserMenuOpen ? 'menu-open' : ''}`}>
                <Link className={`nav-link ${navigation === '/userlist' || navigation === '/userroles' || navigation.startsWith('/userdetail/') ? 'active' : ''} `} onClick={handleUserMenuToggle}>
                  <i className="nav-icon fas fa-user-tie" />
                  <p>
                    Admin
                    <i className="right fas fa-angle-left" />
                  </p>
                </Link>
                <ul className="nav nav-treeview">
                  <li className="nav-item">
                    <Link to='/userlist' className={`nav-link ${navigation === '/userlist' || navigation.startsWith('/userdetail/') ? 'active' : ''} `}>
                      <i className="fa-regular fa-circle nav-icon me-2"></i>
                      <p>Users</p>
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link to='/userroles' className={`nav-link ${navigation === '/userroles' ? 'active' : ''} `}>
                      <i className="fa-regular fa-circle nav-icon me-2"></i>
                      <p>User Roles</p>
                    </Link>
                  </li>
                </ul>
              </li>

              <li className={`nav-item ${isServiceMenuOpen ? 'menu-open' : ''}`}>
                <Link className={`nav-link ${navigation === '/legaltools' || navigation.startsWith('/legaltoolsdetail/') ? 'active' : ''} `} onClick={handleServiceMenuToggle}>
                  <i className="nav-icon fas fa-copy" />
                  <p>
                    Setup
                    <i className="right fas fa-angle-left" />
                  </p>
                </Link>
                <ul className="nav nav-treeview">
                  <li className="nav-item">
                    <Link to='/legaltools' className={`nav-link ${navigation === '/legaltools' || navigation.startsWith('/legaltoolsdetail/') ? 'active' : ''} `}>
                      <i className="fa-regular fa-circle nav-icon me-2"></i>
                      <p>Legal Tools</p>
                    </Link>
                  </li>
                </ul>
              </li>

            </ul>
          </nav>
        </div>
      </aside>

      {/* <!-- Content Wrapper. Contains page content --> */}
      <div className="content-wrapper">
        <div className="content-header">
          <div className="container-fluid px-0">
            <div className="row mb-2 mx-3">
              <div className="col-sm-6">
                {/* <h1 className="m-0">Dashboard</h1> */}
              </div>
              <div className="col-sm-6">
                <ol className="breadcrumb float-sm-right">
                  {/* <li className="breadcrumb-item"><a href="#">Home</a></li> */}
                  {/* <li className="breadcrumb-item active">Dashboard v1</li> */}
                </ol>
              </div>
            </div>
          </div>
        </div>
        {/* <!-- /.content-header --> */}

        {/* <!-- Main content --> */}
        <section className="content">
          <div className="container-fluid my-5 ">
            {children}
          </div>
        </section>
        {/* <!-- /.content --> */}
      </div>
      {/* <!-- /.content-wrapper --> */}
      <footer className="main-footer text-white">
        <strong>&copy; 2024 <a href="https://foundrylawgroup.com/" target="blank">Foundry Law Group</a>. </strong>
        All Rights Reserved.
        {/* <div className="float-right d-none d-sm-inline-block">
          <b>Version</b> 3.2.0
        </div> */}
      </footer>
      <aside className="control-sidebar control-sidebar-dark">
      </aside>
    </div>
  );
};
export default Layout;